import Rule from "./rule";

/**
 * Rule to check if cart contains certain products / variants
 */
class CartIncludesRule extends Rule {
  type = "cart.includes";

  // The Stencil.Helpers that this Rule depends on
  dependencies = {
    evaluate: [],
    hydrateMeta: ["idToGraphQlId", "executeGQL"]
  }

  constructor(config = {}) {
    super(config);
    this.initialize();
  }

  evaluate(data) {
    super.evaluate(data);

    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    let pass = true;
    let variants = this.config.variants ? Array.isArray(this.config.variants) ? this.config.variants : [this.config.variants] : [];
    let products = this.config.products ? Array.isArray(this.config.products) ? this.config.products : [this.config.products] : [];
    pass = data.response.items.some(item => {
      return variants.includes(item.id) || products.includes(item.product_id);
    });

    this.addLog(pass, "In cart", pass ? "In cart" : "Not in cart");
    
    console.log('Pass?', pass);
    console.groupEnd();
    return pass;
  }

  explain() {
    let message = "cart includes";
    let submessages = [
      ...(this.config.variants || []).map(id => `${Stencil.Logger.variant({ title: this.meta[id]?.title, id })} from ${Stencil.Logger.product({ title: this.meta[id]?.product.title, id: this.meta[id]?.product.id.split("/").pop() })}`),
      ...(this.config.products || []).map(id => `TODO`)
    ];
    
    return `${message} ${submessages.join(" or ")}`;
  }

  async hydrateMeta() {
    super.hydrateMeta();
    
    const graphQlIds = [
      ...(this.config.variants || []).map(id => Stencil.Helpers.idToGraphQlId(id, "variant")),
      ...(this.config.products || []).map(id => Stencil.Helpers.idToGraphQlId(id, "product"))
    ];
    
    const result = await Stencil.Helpers.executeGQL(`{
      nodes(ids: ${JSON.stringify(graphQlIds)}) {
        ... on ProductVariant {
          id
          title
          product {
            id
            title
          }
        }
        ... on Product {
          id
          title
        }
      }
    }`, {});
    
    result.data.nodes.forEach(node => {
      this.meta[node.id.split("/").pop()] = node;
    });
  }
}

export default CartIncludesRule;